// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dz-j";
export var fulfillmentFormRail = "_dz-i";
export var headerTitleRow = "_dz-l";
export var orderDetailsWrapper = "_dz-g";
export var orderLinkTrigger = "_dz-2";
export var paymentInformationGrid = "_dz-q";
export var paymentSummaryColumn = "_dz-r";
export var phoneShipmentPickerButton = "_dz-e";
export var phoneShipmentPickerButtonContent = "_dz-f";
export var phoneShipmentPickerButtonWrapper = "_dz-d";
export var phoneShipmentPickerTrigger = "_dz-c";
export var shipmentContainer = "_dz-k";
export var shipmentDetailsMainPane = "_dz-h";
export var shipmentNavigationCard = "_dz-a";
export var shipmentNavigationEdgeTrigger = "_dz-6";
export var shipmentNavigationRail = "_dz-3";
export var shipmentNavigationRailEnter = "_dz-5";
export var shipmentNavigationRailHeader = "_dz-9";
export var shipmentNavigationRailOverlay = "_dz-4";
export var shipmentNavigationScrim = "_dz-7";
export var shipmentSummaryFact = "_dz-n";
export var shipmentSummaryGrid = "_dz-m";
export var shipmentSummaryMetadataRow = "_dz-o";
export var shipmentSummaryTags = "_dz-p";
export var shipmentWorkspace = "_dz-0";
export var shipmentWorkspaceBodyTablet = "_dz-8";
export var shipmentWorkspaceContent = "_dz-b";
export var shipmentWorkspaceHeader = "_dz-1";